export enum EAccountStatus {
  All = 0,
  New = 1,
  Active = 2,
  InActive = 3,
}
export enum EAccountStatusInfo {
  All = 'All',
  New = 'New',
  Active = 'Active',
  InActive = 'Inactive',
}

export enum ECustomerAccountStatus {
  New = 1,
  Verified = 2,
  Deleted = 3,
}

export enum ECustomerAccountStatusInfo {
  New = 'New',
  Verified = 'Verified',
  Deleted = 'Deleted',
}

export enum EOrganizationActions {
  Activate = 2,
  Deactivate = 3,
}

export enum EOrganizationActionsInfo {
  Activate = 'Activate',
  Deactivate = 'Deactivate',
  Edit = 'Edit',
}
